module.exports = __webpack_public_path__ + "static/media/larv_schema.e3bcd4dc.pdf";